export type ServiceIcon =
  | 'drywall'
  | 'hammer'
  | 'paint'
  | 'flooring'
  | 'garage'
  | 'wallpaper'
  | 'stucco'
  | 'ceiling'
  | 'water'
  | 'door'
  | 'tile'
  | 'wrench'

export type Service = {
  id: string
  name: string
  blurb: string
  icon: ServiceIcon
  popular?: boolean
}

export const services: Service[] = [
  {
    id: 'drywall-repair',
    name: 'Drywall Repair',
    blurb: 'Holes, cracks, dents and doorknob blowouts patched so you can’t find them.',
    icon: 'drywall',
    popular: true,
  },
  {
    id: 'drywall-install',
    name: 'Drywall Installation',
    blurb: 'New walls, garage finishing and full tear-outs hung, taped and finished.',
    icon: 'hammer',
  },
  {
    id: 'painting',
    name: 'Interior & Exterior Painting',
    blurb: 'Single rooms to whole homes, with clean lines and real prep work.',
    icon: 'paint',
    popular: true,
  },
  {
    id: 'flooring',
    name: 'Flooring Installation',
    blurb: 'Removal and install of LVP, laminate and tile — baseboards included.',
    icon: 'flooring',
    popular: true,
  },
  {
    id: 'water-restoration',
    name: 'Water Restoration',
    blurb: 'Fast water extraction, drying and rebuild after leaks, floods and burst pipes.',
    icon: 'water',
    popular: true,
  },
  {
    id: 'mold-remediation',
    name: 'Mold Remediation',
    blurb: 'Mold found, safely removed and the damaged material replaced so it stays gone.',
    icon: 'wrench',
  },
  {
    id: 'popcorn',
    name: 'Popcorn Ceiling Removal',
    blurb: 'Scrape, skim and retexture for a clean, modern ceiling.',
    icon: 'ceiling',
  },
  {
    id: 'stucco',
    name: 'Stucco Repairs & Patches',
    blurb: 'Desert-sun cracks and impact damage blended into your existing finish.',
    icon: 'stucco',
  },
  {
    id: 'water-damage',
    name: 'Water Damage Repair',
    blurb: 'Leak-damaged walls and ceilings cut out, dried, rebuilt and matched.',
    icon: 'water',
  },
  {
    id: 'texture',
    name: 'Texture Matching',
    blurb: 'Knockdown, orange peel and smooth finishes matched to the original.',
    icon: 'wrench',
  },
  {
    id: 'wallpaper',
    name: 'Wallpaper Installation',
    blurb: 'Accent walls and full rooms hung straight, with old paper removed.',
    icon: 'wallpaper',
  },
  {
    id: 'garage-door',
    name: 'Garage Door',
    blurb: 'Repairs, panel replacement and tune-ups to keep it running quiet.',
    icon: 'garage',
  },
  {
    id: 'doors-trim',
    name: 'Doors, Trim & Baseboards',
    blurb: 'Interior doors hung, casing and baseboards installed and caulked.',
    icon: 'door',
  },
  {
    id: 'tile',
    name: 'Tile & Backsplash',
    blurb: 'Backsplashes, shower surrounds and cracked tile replaced.',
    icon: 'tile',
  },
]
